import { withStyles } from '@mui/styles';
import Container from './container';
import { styles } from './container.styles';

export default withStyles(styles, { withTheme: true })(Container);
